import { useCallback, useEffect, useRef, useState } from "react"
import { Template } from "../../Components/Template/template"
import { AlertType, barraVermelhoAzul, bgBlue, bgRed, classBorderLabelDark, classBt, classbtAzul, classbtCinzaClaro, classbtColunasVermelho, classbtVerde, classbtVermelho, classDivBackground, classDivBody, classDtCriarAtt, classInput, classInputDark, classLabel, classLabelDark, classUserCriarAtt, classWeigthBt, Clientes, ClientesSearchBox, ContaAReceberAttributes, focusLabelRed, focusRed, InputsRefs } from "../../Utils/Types"
import { useParams } from "react-router-dom"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faClipboardList, faFolder } from "@fortawesome/free-solid-svg-icons"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { IoAddCircleSharp, IoSave } from "react-icons/io5"
import { Icone } from "../../Components/Icones/Index"
import { SearchBox } from "../../Components/SearchBox/SearchBox"
import { Funcoes } from "../../Utils/Funcoes"
import { BsBoxArrowInLeft } from "react-icons/bs"
import { Link } from "react-router-dom"
import { ClientesService } from "../Clientes/ClientesService"
import { FcNook } from "react-icons/fc"
import { ContaAReceberService } from "./ContaAReceberService"
import moment from "moment"
import { AiOutlineClear } from "react-icons/ai"
import { ModalTutorial } from "../../Components/Modal/modal-tutorial"
import { FaVideo } from "react-icons/fa"

export const LancamentoContaAReceber = () => {

    // ----------------- TABS -------------------------------------------------------- 
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)


    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idDupReceber } = useParams<string>()
    const [id, setId] = useState(0)
    const [attributes, setAttributes] = useState<ContaAReceberAttributes>()

    // CLIENTE
    const [idCliente, setIdCliente] = useState<number>(0)
    const [clientesList, setClientesList] = useState<ClientesSearchBox[]>([])
    const [clientes, setClientes] = useState<ClientesSearchBox[]>([])

    const [serie, setSerie] = useState<string>("")
    const [serieCopia, setSerieCopia] = useState<string>("")
    const [data_vencimento, setData_Vencimento] = useState<string>("")
    const [observacao, setObservacao] = useState<string>("")
    const [valor, setValor] = useState<string>("")

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // --------- SEARCHBOX ------------------------------------------------------------
    const [visibleSearchBoxCliente, setVisibleSearchBoxCliente] = useState<boolean>(false)

    // ---------- ATRIBUTOS TUTORIAL --------------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const getAttributes = async () => {
        setLoading(true)

        try {

            const Attributes = await ContaAReceberService.GetAttributes(idDupReceber)

            const ClienteList = Attributes.data.cliente.filter((item: any) => item.id === Attributes.data.contaAReceber?.id_cliente)
            if (ClienteList && ClienteList.length > 0) {
                setIdCliente(ClienteList[0].id)
            }

            setAttributes(Attributes.data)

            if (Attributes && idDupReceber) {

                setId(Attributes.data.contaAReceber.id || 0)
                setIdCliente(Attributes.data.contaAReceber.id_cliente || 0)
                setSerie(Attributes.data.contaAReceber.serie || '')
                setSerieCopia(Attributes.data.contaAReceber.serie || '')

                setData_Vencimento(Attributes.data.contaAReceber.data_vencimento || '')
                setValor(Attributes.data.contaAReceber.valor || 0)
                setObservacao(Attributes.data.contaAReceber.observacao || '')

                if (Attributes.data.contaAReceber.dt_cadastro) {
                    const dataFormatadaCriacao = moment(Attributes.data.contaAReceber.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (Attributes.data.contaAReceber.dt_last_update) {
                    const dataFormatadaAtt = moment(Attributes.data.contaAReceber.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setUserCriador(Attributes.data.contaAReceber.name_user_insert || '')
                setUsertAtt(Attributes.data.contaAReceber.name_user_last_update || '')

            }

            if (Attributes) {
                setClientesList(Attributes.data.cliente)
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados: ${error}`)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAttributes()
    }, []);

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement;
        if (target instanceof HTMLAnchorElement) {
            target.blur();
        }

        Inputfocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
        setVisibleSearchBoxCliente(false)
    }

    useEffect(() => {

        if (tabs[0].active) {
            Inputfocus()
        }

    }, [tabs])


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleChangeDtVencimento = (e: React.ChangeEvent<HTMLInputElement>) => {
        setData_Vencimento(e.target.value)
    }

    const handleChangeSerie = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSerie(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeValor = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeObs = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacao(e.target.value)
    }


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CLIENTES ------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearClienteSelecionado = useCallback(() => {
        const newClienteList = [...attributes?.cliente || []]
        setClientesList(newClienteList)
        setIdCliente(0)

        setVisibleSearchBoxCliente(false)
        boxFocusCliente()

    }, [attributes?.cliente])

    const handleFilterClienteClick = useCallback(async (description: string) => {

        if (description === "") {

            const newClienteList = [...attributes?.cliente || []]
            setClientesList(newClienteList || [])

        } else {

            const newClienteList = [...attributes?.cliente || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setClientesList(newClienteList || [])
        }

    }, [attributes?.cliente])

    const handleClienteSelectClick = useCallback(async (v: Clientes) => {

        if (v) {
            const newClienteList = [...attributes?.cliente || []]
            setClientesList(newClienteList)
            setIdCliente(v.id)
        }

        setVisibleSearchBoxCliente(false)
        boxFocusCliente()

    }, [attributes?.cliente])


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- DUPLICATA RECEBER ---------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novoDupReceber = () => {
        setId(0)
        setIdCliente(0)
        setSerie('')
        setData_Vencimento('')
        setValor('')
        setObservacao('')

        setUserCriador("")
        setDtCriador("")
        setUsertAtt("")
        setDtAtt("")

        Inputfocus()
        handleInputFocus()

        if (messageType === "DANGER") {
            setVisible(false)
        }
    }

    const handleSalvarDupReceber = async () => {

        setVisible(false)
        setLoading(true)

        try {

            handleInputFocus()

            let contaAreceber = {
                id: id,
                data_vencimento: data_vencimento,
                id_cliente: idCliente,
                serie: serie,
                valor: valor,
                observacao: observacao,
            }

            const resp = await ContaAReceberService.Save(contaAreceber)

            if (resp.error === true) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || "")

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? "Dados da duplicata atualizados com sucesso." : resp.msg || "")

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setSerieCopia(resp.data.duplicata.serie)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? "Não foi possível atualizar os dados da  Por favor, tente novamente." : "Não foi possível salvar os dados da  Por favor, tente novamente.")


        } finally {
            setLoading(false)
            Inputfocus()
        }
    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("serie")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 1 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        serie: useRef(null),
        dataVencimento: useRef(null),
        valor: useRef(null),
        cliente: useRef(null),
        observacao: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            handleInputFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 3) {
                setVisibleSearchBoxCliente(true)
                inputFocusCliente()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[0].active) {

                event.preventDefault()

                const inputSearchCliente = document.getElementById('inputSearchBox-cliente') as HTMLInputElement

                if (document.activeElement === inputSearchCliente) {

                    inputsRefs['observacao'].current?.focus()
                    setVisibleSearchBoxCliente(false)

                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [tabs])

    const handleInputFocus = () => {
        setVisibleSearchBoxCliente(false)
    }

    const boxFocusCliente = () => {
        // Move o foco para o input correspondente à chave 'cliente'.
        inputsRefs['cliente'].current?.focus()
    }

    const clickSearchBoxCliente = useCallback(() => {
        setVisibleSearchBoxCliente((prevState) => {
            const newState = !prevState;
            if (newState) {
                inputFocusCliente();
            }
            return newState;
        });
        boxFocusCliente();
    }, [])

    const inputFocusCliente = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cliente`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 2 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab' && tabs[1].active) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs])

    const btNovoVisible = parseInt(idDupReceber || '') > 0 ? 'invisible hidden' : 'visible'

    return (

        <Template isLoading={loading} >

            <div className={`${classDivBackground}`}>

                <div id="div-body" role='button' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] w-full flex items-center my-3 px-2`}>
                            <FcNook className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all mx-2`}>{parseInt(idDupReceber || '') || id > 0 ? `Editar - Duplicatas a Receber - ${serieCopia == undefined ? '' : serieCopia}` : `Cadastro - Duplicatas a Receber`}</span>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} shadow-md shadow-blue-600`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (

                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}
                            </div>

                            <div className={`${tabs[0].active ? `block` : `hidden`} relative`}>

                                <div className={`w-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.serie} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'serie')} id="serie" className={`${classInput} ${classInputDark}`} type="text" inputMode="numeric" placeholder=' ' value={serie} autoComplete="off" onFocus={handleInputFocus} onChange={handleChangeSerie} />
                                        <label htmlFor="serie" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Série</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${data_vencimento != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.dataVencimento} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'dataVencimento')} id="dtVencimento" className={`${classInput} ${classInputDark} ${data_vencimento !== '' ? '' : focusRed} ${data_vencimento === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type="date" min="1900-01-01" max="9999-12-31" placeholder=' ' value={data_vencimento} autoComplete="off" onFocus={handleInputFocus} onChange={handleChangeDtVencimento} />
                                        <label htmlFor="dtVencimento" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${data_vencimento !== '' ? '' : focusLabelRed}`}>Data de Vencimento</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${parseFloat(valor) > 0 ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.valor} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'valor')} id="valor" className={`${classInput} ${classInputDark} ${parseFloat(valor) > 0 ? '' : focusRed}`} type="text" inputMode="numeric" placeholder=' ' value={valor} autoComplete="off" onFocus={handleInputFocus} onChange={handleChangeValor} />
                                        <label htmlFor="valor" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${parseFloat(valor) > 0 ? '' : focusLabelRed}`}>Valor (R$)</label>
                                    </div>

                                    <div className={`relative col-span-12 xl:col-span-4 2xl:col-span-6`}>

                                        <div ref={inputsRefs['cliente']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'cliente')} />
                                        <div className={`${barraVermelhoAzul} ${idCliente > 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={clientesList}
                                            idRegistro={idCliente || undefined}
                                            label='Cliente'
                                            componentId='cliente'
                                            visibleTAB={visibleSearchBoxCliente}
                                            borda={true}
                                            setDataClick={handleClienteSelectClick}
                                            clearDataClick={handleClearClienteSelecionado}
                                            filterDataClick={handleFilterClienteClick}
                                            clicado={clickSearchBoxCliente}
                                        />
                                    </div>

                                    <div className={`relative col-span-12`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue} bottom-1 dark:bottom-1`} />
                                        <textarea ref={inputsRefs.observacao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'observacao')} id="obs" className={`${classInput} ${classInputDark} min-h-[160px] lg:min-h-[120px] resize-none`} placeholder=" " autoComplete='off' value={observacao} onFocus={handleInputFocus} onChange={handleChangeObs} />
                                        <label htmlFor="obs" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/contaAreceber" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={novoDupReceber} className={`${classBt} ${classbtCinzaClaro} ${btNovoVisible} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className='mr-[5px]' /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleSalvarDupReceber} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idDupReceber || '0') > 0 || id != 0 ? !loading ? `Atualizar` : `Aguarde` : !loading ? `Salvar` : `Aguarde`}

                                    </button>
                                </div>

                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoDupRec" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoDupRec" className={`${classDtCriarAtt}`} >{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoDupRec" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoDupRec" className={`${classDtCriarAtt}`} >{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttDupRec" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttDupRec" className={`${classDtCriarAtt}`} >{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttDupRec" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttDupRec" className={`${classDtCriarAtt}`} >{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_dupReceber.mp4'
                            title='Tutorial sobre duplicatas a receber'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }

                </div>

            </div>

        </Template>

    )

}